import {_, moment, lockr, memoize, uiConstants, exportAndDownloadService} from '@api'
import {configs, onSiteError, site, globalStores as stores} from '@stores'
import * as colorConvert from 'color-convert'

export type C8ImageSize = 'smallImage' | 'thumbnailImage' | 'largeImage' | 'image'
export type ImageRatio = 'square' | 'landscape' | 'portrait' | 'auto' | string
export type PageColumns = 'standard' | 'compact'

const Libraries = {
  MATERIAL: 'materials',
  HARDWARE: 'hardware',
  STYLE: 'styles',
  COLOR: 'colors'
}

const getInitcapString=(str:string) => {
  return _.startCase(_.toLower(str))
}
const getLibraryDisplayName = (specTypeMapping, type: string) => {
  if (!type) return null
  let defaultDisplayName = type.charAt(0).toUpperCase() + type.slice(1)
  let splitBy = type.slice(0, 5);
  let libraryType = type.toLowerCase() || specTypeMapping && specTypeMapping[type] && specTypeMapping[type].displayName.singular.toLowerCase();
  if(libraryType === "merch product version") {
    return defaultDisplayName = `${getInitcapString(splitBy)} ${getInitcapString(type.split(splitBy)[1])}`
  } else if(libraryType === "merchproduct") {
    type = 'merchProducts'
    return specTypeMapping && specTypeMapping[type] && specTypeMapping[type].displayName.singular ? specTypeMapping[type].displayName.singular || defaultDisplayName : defaultDisplayName
  }
  let displayName        = specTypeMapping && specTypeMapping[type] && specTypeMapping[type].displayName.plural ? specTypeMapping[type].displayName.plural || defaultDisplayName : defaultDisplayName
  return displayName
}

const buildImageUrl = (imageWrapper, size : C8ImageSize = null) => {
  // (style.images && style.images.length) ? `${config.graphqlEndpoint}images/${[style.images[0].image.smallImage]}?token=${lockr.get('access_token')}` : ''
  let imageUrl
  if (imageWrapper && imageWrapper.length) {
    const defaultImageWrapper = _.find(imageWrapper, wrapper => wrapper.position === 0)
    if (defaultImageWrapper) {
      let imageEndpoint = defaultImageWrapper.image[size || 'thumbnailImage']
      if (!imageEndpoint) {
        console.error(`Unable to create image url for ${size}`, defaultImageWrapper)
        imageEndpoint = defaultImageWrapper.image.image
      }
      imageUrl = imageEndpoint && defaultImageWrapper ? `${configs.config.graphqlEndpoint}images/${imageEndpoint}?token=${lockr.get('access_token')}` : undefined
    }
  }
  return imageUrl
}

const downloadExcel = async (prefix: string, link, method, body = null) => {
  const date = new Date()
  const fileName = `${prefix}${moment(date).format('MMDDYYYYHHmm')}.xlsx`
  await exportAndDownloadService(link,method,body,fileName);
}

const guid = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  }
  return s4() + s4() + s4() + s4()
}

const differenceInObject = (object, base) => {
  var changes = (object, base): any => {
    let arrayIndexCounter = 0
    return _.transform(object, function (result, value, key) {
      if (!_.isEqual(value, base[key])) {
        let resultKey = _.isArray(base) ? arrayIndexCounter++ : key
        result[resultKey] = (_.isObject(value) && _.isObject(base[key])) ? base[key].id ? { exId: base[key].id, ...changes(value, base[key]) } : changes(value, base[key]) : value
      }
    })
  }
  return changes(object, base)
}

const checkIntegersOnly = (event) => {
  const exp = /^\d{1,3}$/g;
  if (!exp.test(event.key)) {
    event.preventDefault();
  }
}

const getHsb = (hex, rgb) => {
  if (hex) {
      return colorConvert.hex.hsv.raw(hex)
  } else if (rgb) {
      return colorConvert.rgb.hsv.raw(rgb.r, rgb.g, rgb.b)
  }
  return null
}

const tryParseJson = (str) => {
  try {
    return JSON.parse(str)
  } catch (e) {
      return null
  }
}

export {
  Libraries,
  buildImageUrl,
  guid,
  downloadExcel,
  getLibraryDisplayName,
  differenceInObject,
  checkIntegersOnly,
  getHsb,
  tryParseJson,
}

export const removeUndefinedsNested = (obj, removeEmptyObjects = false, parent = null) => {
  //let result = !parent ? _.cloneDeep(obj) : obj
  let result = obj

  Object.keys(result).forEach(key => {
    if (removeEmptyObjects && _.isEmpty(result[key])) {
      delete result[key]
    }
    else if (result[key] && typeof obj[key] === 'object') removeUndefinedsNested(result[key], removeEmptyObjects, result);
    else if (result[key] === undefined) delete result[key];
  })
  return result
}

export const recursivelyRemovePrivateFields = (obj, callbackOnTraverse: (k, obj, path: string[]) => void = null, path: Array<string> = []) => {
  let result = obj

  if (!result) return result

  Object.keys(result).forEach(key => {
    callbackOnTraverse && callbackOnTraverse(key, result, path)

    if (key == '__parent' || key == '__path') {
      delete result[key]
    } else {
      const newPath = [...path, key]
      if (result[key] && _.isArray(obj[key])) {
        result[key] = obj[key].map(v => recursivelyRemovePrivateFields(v, callbackOnTraverse, newPath))
      } else if (result[key] && typeof obj[key] === 'object') recursivelyRemovePrivateFields(result[key], callbackOnTraverse, newPath)
    }
  })
  return result
}

export const deepFreeze = obj => {
  Object.keys(obj).forEach(prop => {
    if (_.isArray(obj[prop])) { obj[prop].forEach(v => deepFreeze(v))}
    else if (typeof obj[prop] === 'object') deepFreeze(obj[prop])
  })
  return Object.freeze(obj)
}


// WEBPACK FOOTER //
// ./src/utils/appUtils.ts